import { PaginationQueryParams } from '../../../../../constants/apiRoutes/paginationQueryParams.ts';
import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { ApiRoute } from '../../../../../constants/apiRoutes/apiRoute.ts';
import { ReactElement } from 'react';
import { BaseSkeletonStack } from '@cksoftware/react-base';
import { useAuctionListData } from '../../../hooks/useAuctionListData.ts';

interface AuctionListProps<T, TParams extends PaginationQueryParams> {
  title: string;
  emptyListMessage?: string;
  route: ApiRoute<TParams>;
  queryParameters?: Partial<TParams>;
  renderItem: (item: T) => ReactElement;
}

export const AuctionList = <TParams extends PaginationQueryParams>(props: AuctionListProps<any, TParams>) => {
  const { title, route, queryParameters, emptyListMessage, renderItem } = props;

  const { items, isLoading, isEmpty } = useAuctionListData(route, queryParameters);

  return (
    <Flex gap={'16px'} direction={'column'}>
      <Text alignItems='center' fontSize='2xl' fontWeight='semibold'>
        {title}
      </Text>
      <Flex gap={'16px'} direction={'column'}>
        <BaseSkeletonStack isLoading={isLoading} />
        {isEmpty && (
          <Center>
            {' '}
            <Text>{emptyListMessage}</Text>
          </Center>
        )}
        {items.map((item) => (
          <Box key={item.Id}>{renderItem(item)}</Box>
        ))}
      </Flex>
    </Flex>
  );
};
